import React from 'react'
import AsyncSelect from 'react-select/async'
import debounce from 'debounce-promise'

const Usage = ({ state: { usage }, setState }) => {
  return (
    <div className="my-4">
      <div className="text-gray-500 mb-2">Usage / Airing time</div>
      <AsyncSelect
        value={usage}
        onChange={(usage) => setState((state) => ({ ...state, usage }))}
        openMenuOnFocus
        placeholder="Usage"
        cacheOptions
        defaultOptions
        loadOptions={
          debounce((query) => fetch(`/rest/v1/orderusage?pageSize=999&search[deleted]=0&search[name]=${query}`)
              .then((response) => response.json())
              .then((items) => items.map((data) => ({
                value: data.uid,
                label: data.name
              })))
            , 250)
        }
      />
    </div>
  )
}

export default Usage
